import { addMnemonicGlyphBadges } from "@-/dev.improve.haniverse.lib.morpheme.description";
import { useMemo } from "react";
import { EnrichedMarkdownText } from "@-/com.npmjs.react-native-enriched-markdown";
import { Platform } from "@-/com.npmjs.react-native";
import { useThemedMarkdownStyle } from "#use-themed-markdown-style";

// Android's native Markdown renderer does not preserve Han Composite anywhere inside a link. On
// the Pixel even a plain linked stroke draws as a LastResort box, while the same glyph in the
// paragraph run draws correctly. Keep the term linked, attach the glyph outside that native link
// run with nonbreaking characters, and let iOS/web retain the rounded linked code badge.
const GLYPH_DECORATION = Platform.OS === "android" ? "outside-link" : "code-badge";

/**
 * An authored mnemonic as the Learn card's mnemonic section renders it: the mnemonic markdown
 * style, its line height, and component links drawn as glyph badges. `grapheme` is the
 * character the mnemonic belongs to, whose own link stays a plain underlined term.
 */
export function MnemonicMarkdownRenderer({
  grapheme,
  mnemonic,
  onLinkPress,
}: {
  grapheme: string;
  mnemonic: string;
  onLinkPress?: (event: { url: string }) => void;
}) {
  const markdownStyle = useThemedMarkdownStyle("mnemonic");
  const markdown = useMemo(
    () => addMnemonicGlyphBadges(mnemonic, grapheme, GLYPH_DECORATION),
    [grapheme, mnemonic],
  );
  return (
    <EnrichedMarkdownText
      markdown={markdown}
      markdownStyle={markdownStyle}
      onLinkPress={onLinkPress}
    />
  );
}
